//#region : Imports

import { Component, OnInit } from "@angular/core";

import Swal from "sweetalert2";

import { GlobalsService } from "../../globals.service";

import { Router, ActivatedRoute } from "@angular/router";

import { trigger, transition, style, animate } from "@angular/animations";
import { THIS_EXPR } from "@angular/compiler/src/output/output_ast";

declare var $: any;
declare var jQuery: any;
declare var intlTelInputUtils: any;

//#endregion

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
  animations: [
    trigger("inOutAnimation", [
      transition(":enter", [
        style({
          opacity: 0,
        }),
        animate(
          "1s ease-out",
          style({
            opacity: 1,
          })
        ),
      ]),
    ]),
  ],
})
export class LoginComponent implements OnInit {
  private busy: boolean = false;
  private loginState: "login" | "2FA" | "2FA-register" | "reset-password" =
    "login";
  private qrCode: string | undefined = undefined;
  private otpInput: string = "";
  private username: string = "";
  private password: string = "";
  private resetPass1: string = "";
  private resetPass2: string = "";
  private resetPassMessage: string = "";
  private phoneInput: any;
  private newRegisterUser: any = {
    name: "",
    surname: "",
    email: "",
    password: "",
    confirmPass: "",
    phone: "",
    companyName: "",
  };

  constructor(private globals: GlobalsService, private router: Router) {
    //Reset message
    this.resetPassMessage = "";

    if (location.pathname.indexOf("resetpass") != -1) {
      this.loginState = "reset-password";

      this.globals.peopleGetByToken(
        (response?: any) => {
          //Success
          if (response && response.person) {
            this.username = response.person.username;

            this.resetPassMessage = `Hello ${response.person.name},`;
          } else {
            this.globals.showWarningAlert(
              "Not Found",
              "The password reset might have expired.<br><br>Please try again.",
              () => {
                this.loginState = "login";
                this.router.navigate([""]);
              }
            );
          }
        },
        () => {
          //Error
          this.globals.showWarningAlert(
            "Not Found",
            "The password reset might have expired.<br><br>Please try again.",
            () => {
              this.loginState = "login";
              this.router.navigate([""]);
            }
          );
        }
      );
    }
  }

  ngOnInit(): void {}

  ngAfterViewInit() {
    this.setupCustom();
  }

  setupCustom() {
    var input = document.querySelector("#phoneInput");
    this.phoneInput = (window as any).intlTelInput(input, {
      nationalMode: false,
      separateDialCode: true,
      formatOnDisplay: false,
      preferredCountries: ["za"],
      placeholderNumberType: "MOBILE",
      utilsScript: "assets/intlPhone/js/utils.js",
      customPlaceholder: (
        selectedCountryPlaceholder: any,
        selectedCountryData: any
      ) => {
        return "e.g. " + selectedCountryPlaceholder;
      },
    });

    //CSS fixes
    $(".iti").css("width", "100%");
    $(".iti__flag-container").css("padding", "0px");
  }
  getNumber(): string {
    let number: string = this.phoneInput.getNumber(
      intlTelInputUtils.numberFormat.E164
    );

    //Remove the plus prefix
    number = number.replace("+", "");

    return number;
  }
  onCustomChange() {
    //Get the defaults
    let address: string = $("#device-address").val();
    let label = address;
    let isNumber = address.match(/^[0-9]*$/gm);

    //Phone number or username?
    if (isNumber != null) {
      //Validate the phone number
      let isValid = this.phoneInput.isValidNumber();

      //Format the address and label
      if (isValid) {
        address = this.getNumber();
        label = `Phone (${address})`;
      } else {
        address = undefined;
      }
    }

    //Update display
    this.newRegisterUser.phone = address;
  }

  forgetPassword() {
    this.sendRecoveryEmail();
  }

  handleProgress(state) {
    this.busy = state;
  }

  login() {
    //Login to the IoT also
    this.globals.containerLogin(() => {
      this.globals.accountInfo(() => {
        //Success
        this.globals.currentView = "dashboard";
        this.router.navigate([this.globals.currentPage]);
        this.busy = false;
      });
    });
  }

  doLogin(otp?: string, tfa: "enabled" | "skip" | "no-ask" = "enabled") {
    //Get the username and password
    let user = this.username;
    let pass = this.password;

    //Empty?
    if (user && pass) {
      //Start progress
      this.busy = true;

      //Login request
      this.globals.login(
        user,
        pass,
        null,
        otp,
        "no-ask",
        () => {
          //Is there secondary accounts linked to this user?
          if (
            this.globals.acclist !== null &&
            this.globals.acclist.length > 0
          ) {
            //Get the context
            let me = this;

            //Show the "choose account" modal
            $("#modal-change-account").modal({
              backdrop: "static",
            });

            $("#modal-change-account").modal("show");
          } else {
            //Login to the IoT also
            this.login();
            // this.globals.containerLogin(() =>
            // {
            //     this.globals.accountInfo(() =>
            //     {
            //         //Success
            //         this.globals.currentView = "dashboard";
            //         this.router.navigate([this.globals.currentPage]);
            //         this.busy = false;
            //     });
            // });
          }
        },
        (res?: any) => {
          if (res && (res.message == "User not active" || res.error == 108)) {
            this.globals.showWarningAlert("Error", "Account suspended.");
          } else if (res && res.message == "No active accounts") {
            this.globals.showWarningAlert(
              "Error",
              "No active accounts. Please contact the person responsible for your account for help with dashboard access."
            );
          } else {
            //Failure
            if (this.loginState == "2FA") {
              this.globals.showWarningAlert(
                "Login Failed",
                "Incorrect code entered."
              );
            } else {
              this.globals.showWarningAlert(
                "Login Failed",
                "Username or Password is incorrect."
              );
            }
          }

          this.busy = false;
        },
        (result: any) => {
          //Two factor authentication
          let tfa: "scan" | "otp" = result.tfa;

          if (tfa == "scan") {
            //The server ask that I enter the OTP
            this.loginState = "2FA-register";
            this.qrCode = result.qrData;
          } else if (tfa == "otp") {
            //The server ask that I enter the OTP
            this.loginState = "2FA";
          } else {
            //Should not get here
            this.loginState = "login";
          }

          this.busy = false;
        }
      );
    } else {
      //Bad username and password
      this.globals.showWarningAlert(
        "Login Failed",
        "The username or password cannot be empty."
      );
    }
  }

  changeAccount(name: string, accid: string, primary?: boolean) {
    let me = this;
    let prim = primary ? primary : false;

    //Hide the dialog
    $("#modal-change-account").modal("hide");

    if (accid !== null && !prim) {
      //Must change the account
      this.globals.changeAccount(
        accid,
        () => {
          this.login();
        },
        () => {
          //Failure
          this.handleProgress(false);
        }
      );
    } else {
      this.login();
    }
  }

  showRegisterModal() {
    $("#show-register-modal").modal("show");
  }

  registerAccount() {
    this.validateRegFields(this.newRegisterUser, () => {
      //Validate user valid
      // this.globals.peopleExistsByUsername(this.newRegisterUser.email, (person) =>
      // {

      this.newRegisterUser.phone = this.getNumber();

      this.globals.accountRegisterNew(
        this.newRegisterUser.companyName,
        this.newRegisterUser.name,
        this.newRegisterUser.phone,
        this.newRegisterUser.email,
        this.newRegisterUser.password,
        (r: any) => {
          //Success
          //Close modal
          $("#show-register-modal").modal("hide");

          //Display different modals depending on activateAccount variable
          if (this.globals.buildSettings.activateAccount) {
            this.globals.showSuccessAlert(
              "Registration Successful",
              "You can now log in using your selected username and password."
            );
          } else {
            this.globals.showSuccessAlert(
              "Registration Successful",
              "You will be notified when your account has been verified and approved. You will not be able to log in until your account has been verified."
            );
          }
        },
        () => {
          //
        }
      );

      // });
      // }
      // });
    });
  }

  validateRegFields(fields, onSuccess: () => void) {
    let flag = false;
    let msgParams = [];

    if (fields.name == "" || fields.name.length == 0) {
      flag = true;
      msgParams.push("name");
    }

    if (fields.companyName == "" || fields.companyName.length == 0) {
      flag = true;
      msgParams.push("company name");
    }

    if (fields.email == "" || fields.email.length == 0) {
      flag = true;
      msgParams.push("email");
    }
    if (fields.password == "" || fields.name.password == 0) {
      flag = true;
      msgParams.push("password");
    }
    if (fields.confirmPass == "" || fields.name.confirmPass == 0) {
      flag = true;
      msgParams.push("password confirmation");
    }
    if (fields.phone == "" || fields.name.phone == 0) {
      flag = true;
      msgParams.push("phone");
    }

    if (!flag) {
      onSuccess();
    } else {
      //Error message
      let msg = "The following fields must be completed: ";

      for (let i = 0; i < msgParams.length; i++) {
        if (i == 0) {
          msg = msg.concat("<b>" + msgParams[i] + "</b>");
        } else {
          msg = msg.concat(", " + "<b>" + msgParams[i] + "</b>");
        }
      }

      this.globals.showWarningAlert("Invalid fields", msg);
    }
  }

  doVerify() {
    this.doLogin(this.otpInput, "enabled");
  }

  sendRecoveryEmail() {
    let username = this.username;

    if (username && username.length != 0) {
      //Check user exists
      // this.globals.peopleExistsByUsername(username, (r: any) =>
      // {
      //     //Ask to send
      //     if (r.exists)
      //     {
      this.globals.showConfirmAlert(
        "Confirmation",
        "You will receive an email to reset your password.",
        "SEND EMAIL",
        "CANCEL",
        () => {
          this.busy = true;

          this.globals.resetpass(
            username,
            (r: any) => {
              //Success
              this.busy = false;

              if (
                r &&
                r.data &&
                r.data.accepted &&
                r.data.accepted.length > 0
              ) {
                let addr = r.data.accepted[0];
                this.globals.showSuccessConfirm(
                  "Success",
                  `The reset link was sent to ${addr}.`,
                  "OK"
                );
              } else {
                //Failure
                this.globals.showWarningAlert(
                  "Error",
                  "Email could not be sent. "
                );
              }
            },
            () => {
              //Failure
              this.busy = false;
              this.globals.showWarningAlert(
                "Error",
                "Email could not be sent. Your account may have been suspended."
              );
            }
          );
        }
      );
      // }
      // else
      // {
      //     this.globals.showWarningAlert("Error", "User does not exist.")
      //     }
      // }, () =>
      // {
      //     //Error
      //     this.globals.showWarningAlert("Error", "User does not exist.")
      // });
    } else {
      this.globals.showWarningAlert("Error", "No username provided.");
    }
  }

  clearPasswords() {
    this.resetPass1 = "";
    this.resetPass2 = "";
  }

  resetPassword() {
    //Check if passwords match
    if (
      this.resetPass1.length > 0 &&
      this.resetPass1 == this.resetPass2 &&
      this.globals.validatePwd(this.resetPass1)
    ) {
      this.globals.peopleUpdatePassword(
        this.resetPass1,
        (r: any) => {
          //Success
          this.globals.showSuccessAlert(
            "SUCCESS",
            `Password for <b>${this.username}</b> updated.<br><br>Note that your 2FA was also reset.`
          );

          //Go back to the login page
          this.loginState = "login";
          this.router.navigate([""]);
        },
        () => {
          //Failure
          this.globals.showWarningAlert(
            "Update Password",
            "The password update failed."
          );
          this.clearPasswords();
          //Go back to the login page
          this.loginState = "login";
          this.router.navigate([""]);
        }
      );
    } else {
      if (this.resetPass1 !== this.resetPass2) {
        this.globals.showWarningAlert(
          "Update Password",
          "The passwords don't match."
        );
        this.clearPasswords();
      } else {
        this.globals.showWarningAlert(
          "Update Password",
          "The password doesn't contain all the prescribed characters."
        );
        this.clearPasswords();
      }
    }
  }
}
